import React, { useState } from "react";

const faqs = [
  {
    question: "How do I book a cab?",
    answer:
      "You can book a cab through our website or mobile app. Simply enter your pickup and drop-off locations, select your ride, and confirm.",
  },
  {
    question: "What payment methods do you accept?",
    answer:
      "We accept credit/debit cards, UPI, mobile wallets, and cash.",
  },
  {
    question: "How can I track my ride?",
    answer:
      "Track your ride in real-time via the confirmation link or mobile app.",
  },
  {
    question: "Can I cancel or modify my booking?",
    answer:
      "Yes, go to 'My Bookings' section. Charges may apply depending on timing.",
  },
  {
    question: "Are drivers verified?",
    answer:
      "Yes, all drivers are background-checked and trained professionals.",
  },
  {
    question: "Can I schedule a ride?",
    answer:
      "Yes, you can pre-book your ride anytime in advance.",
  },
  {
    question: "Is service available 24/7?",
    answer:
      "Yes, SRS Cab Service operates 24/7 for your convenience.",
  },
  {
    question: "Do you offer airport rides?",
    answer:
      "Yes, we provide airport pickup and drop services.",
  },
  {
    question: "Customer support available?",
    answer:
      "Yes, our support team is available 24/7 via phone, email, and chat.",
  },
  {
    question: "What if cab is late?",
    answer:
      "Contact support immediately, we’ll arrange another cab quickly.",
  },
];

const FAQSection = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  return (

<>


        <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title">Faqs</h2>
           
          </div>
        </div>
      </div>
    </div>
    <section className="faq-section-dark py-2">
      <div className="container">
        <div className="text-center mb-5">
          <h2 className="faq-title">SRS Cab Service FAQs</h2>
          {/* <p className="faq-subtitle">
            Everything you need to know before booking your ride
          </p> */}
        </div>

        <div className="faq-container">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className={`faq-card ${activeIndex === index ? "active" : ""}`}
              onClick={() =>
                setActiveIndex(activeIndex === index ? null : index)
              }
            >
              <div className="faq-question">
                <h6>{faq.question}</h6>
                <span>{activeIndex === index ? "−" : "+"}</span>
              </div>

              <div
                className="faq-answer"
                style={{
                  maxHeight: activeIndex === index ? "200px" : "0px",
                }}
              >
                <p>{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
</>
  );
};

export default FAQSection;